<div class="page-bg">
  <div class="container">
    <ng-container *ngIf="loading">
      <div class="loader-spinner loader-wrap">
        <div class="loadingio-spinner-spinner-32cs6uvfc5">
          <div class="ldio-1tl0ero9yn7">
            <div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>
          </div>
        </div>
      </div>
      
      </ng-container>
      <ng-container *ngIf="!loading">
        <div class="w-100 mt-1" *ngIf="showClosestRegionMessage">
          <div class="w-100"
               style="text-align: center; font-weight: bold; font-size: 13px;">
            No results for {{ SubregionName }}, {{ RegionName }}
          </div>
          <div class="w-100" style="text-align: center; font-weight: bold;">
            Showing results from {{ ClosestSubregionNameIfNoResult }}
          </div>
        </div>

        <div *ngIf="listLayout == listLayoutType.LIST" class="w-100 listLayoutType listLayoutType-list">
          <div *ngFor="let card of cardList; index as i" class="checker mt-1 p-1">
            <div class="wrap" (click)="openAdv(card.advertisementId)">
              <div class="row py-1">
                <div class="col-11 item">
                  <small class="adv-date">{{ getAdvDate(card) }}</small>
                  <span [ngClass]="{ 'non-demo-for-demo-user': !this.isSeen(card) }"><b>{{ getAdvTag(card) + getAdvTitle(card) }}</b></span>
                  <span *ngIf="!card.isThirdParty">( {{  getLocation(card) }} )</span>
                </div>
                <div class="col-1 text-right d-flex justify-content-end align-items-center">
                  <div class="d-inline-flex" *ngIf="hasAdvertismentImage(card)">
                    <i class="material-icons"
                       [matMenuTriggerFor]="menu"
                       #menuTrigger="matMenuTrigger"
                       (mouseleave)="menuTrigger.closeMenu()"
                       (mouseenter)="openImageMenu(menuTrigger)">camera_alt</i>
                    <mat-menu backdropClass="custom__menu_dummy_image"
                              class="customized-image-menu"
                              style="pointer-events: none;"
                              #menu="matMenu"
                              [overlapTrigger]="true"
                              xPosition="before">
                      <span style="
                      display: block;
                      width: 100%;
                      height: 100%;
                      pointer-events: none;
                    ">
                        <img [src]="getImageFromCard(card)"
                             style="width: 100%; height: auto;" />
                      </span>
                    </mat-menu>
                  </div>

                  <i *ngIf="getPremiumText(card) != '' && enableSubscription"
                     class="star-icon material-icons mr-2"
                     matTooltip="{{ getPremiumText(card) }}"
                     matTooltipPosition="above">star</i>
                  <div class="third-party-ad-text mr-2" *ngIf="card.isThirdParty">
                    <span style="color: #e94480">sponsored</span>
                  </div>
                </div>
              </div>
            </div>

            <ng-container *ngIf="service.advService.bannersEnabled">
              <div class="adsContainer"
                   *ngIf=" (!isPremium || !service.enableSubscription) && i != 0 && i + 1 != cardList.length && (i + 1) % 8 == 0">
                <app-banner-zone-map [zoneType]="['Desktop-Zone-Horizontal-Top', 'Desktop-Zone-Horizontal-Bottom']"></app-banner-zone-map>
              </div>
            </ng-container>
          </div>

          <div *ngIf="length == 0 && !loading" class="w-100 not-found">
            0 results found&nbsp;<span *ngIf="SubregionName != '' && RegionName != ''">in {{ SubregionName }}, {{ RegionName }}</span>
          </div>
        </div>

        <div *ngIf="listLayout == listLayoutType.GRID" class="pt-5 w-100 listLayoutType listLayoutType-grid">
          <mat-grid-list [cols]="breakpoint"
                         rowHeight="1:1.4"
                         gutterSize="50px"
                         (window:resize)="onResize($event)">
            <mat-grid-tile *ngFor="let card of cardList" class="grid-card">
              <!-- material card here -->
              <app-adv-small (click)="openAdv(card.advertisementId)"
                             [Date]="getAdvDate(card)"
                             [Description]="card.content"
                             [DisplayMode]="listLayoutType.GRID"
                             [ImageUrl]="getImageFromCard(card)"
                             [Location]="getLocation(card)"
                             [Tag]="getAdvTag(card)"
                             [Title]="getAdvTitle(card)"
                             [IsThirdParty]="card.isThirdParty"
                             [PremiumText]="getPremiumText(card)"></app-adv-small>
            </mat-grid-tile>
            <div *ngIf="length == 0 && !loading" class="w-100 not-found">
              0 results found&nbsp;<span *ngIf="SubregionName != '' && RegionName != ''">in {{ SubregionName }}, {{ RegionName }}</span>
            </div>
          </mat-grid-list>
        </div>

        <div *ngIf="listLayout == listLayoutType.TILE" class="w-100 listLayoutType listLayoutType-tile">
          <div fxLayout="row wrap"
               fxLayout.lt-sm="column"
               fxLayoutAlign="flex-start"
               fxLayoutGap="10px">
            <div *ngFor="let card of cardList"
                 class="mt-2"
                 fxFlex="0 1 calc(25% - 10px)"
                 fxFlex.lt-md="0 1 calc(50% - 10px)"
                 fxFlex.lt-sm="100%">
              <!-- material card here -->
              <app-adv-small (click)="openAdv(card.advertisementId)"
                             [Date]="getAdvDate(card)"
                             [Description]="card.content"
                             [DisplayMode]="listLayoutType.TILE"
                             [ImageUrl]="getImageFromCard(card)"
                             [Location]="getLocation(card)"
                             [Title]="getAdvTitle(card)"
                             [IsThirdParty]="card.isThirdParty"
                             [PremiumText]="getPremiumText(card)"></app-adv-small>
            </div>
            <div *ngIf="length == 0 && !loading" class="w-100 not-found">
              0 results found&nbsp;<span *ngIf="SubregionName != '' && RegionName != ''">in {{ SubregionName }}, {{ RegionName }}</span>
            </div>
          </div>
        </div>

        <div *ngIf="listLayout == listLayoutType.ROW" class="w-100 listLayoutType listLayoutType-row">
          <div class="w-100">
            <div *ngFor="let card of cardList" class="mt-2">
              <!-- material card here -->
              <app-adv-small (click)="openAdv(card.advertisementId)"
                             [Date]="getAdvDate(card)"
                             [Description]="card.content"
                             [DisplayMode]="listLayoutType.ROW"
                             [ImageUrl]="getImageFromCard(card)"
                             [Location]="getLocation(card)"
                             [Title]="getAdvTag(card) + getAdvTitle(card)"
                             [IsThirdParty]="card.isThirdParty"
                             [PremiumText]="getPremiumText(card)"></app-adv-small>
            </div>
          </div>
          <div *ngIf="length == 0 && !loading" class="w-100 not-found">
            0 results found&nbsp;<span *ngIf="SubregionName != '' && RegionName != ''">in {{ SubregionName }}, {{ RegionName }}</span>
          </div>
        </div>

        <mat-toolbar class="w-100 mt-2" color="transparent-bg" *ngIf="length > 0">
          <mat-toolbar-row class="p-0" fxLayout="row" fxLayoutAlign="end center">
            <mat-paginator (page)="pageEvent = $event"
                           [length]="length"
                           [pageIndex]="pageNumber"
                           [pageSizeOptions]="pageSizeOptions"
                           [pageSize]="pageSize"
                           (page)="pageChange($event)"></mat-paginator>
          </mat-toolbar-row>
        </mat-toolbar>
      </ng-container>

  </div>
</div>
